import { Button } from "semantic-ui-react";
import React from "react";

export function ProductServiceContact() {
  return <div className="flex flex-row items-center justify-between nh1">
    <div className={"w-100 ma1"}><Button fluid basic size={"small"} as={"a"} href={"mailto:info@orfix.com"}>E-Mail</Button></div>
    <div className={"w-100 ma1"}><Button fluid basic size={"small"} as={"a"} href={"tel:490417881840"}><span className="f6 nowrap">+49 (0) 4178 8184-0</span></Button></div>
  </div>
}


// WEBPACK FOOTER //
// ./src/theme/orfix/pages/ProductServiceContact.js